module.exports = __webpack_public_path__ + "img/Datalore_icon.a6c1e270.png";